// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Added v7 — see `ChannelModifier.schema_version`.
 *
 * What VTS sends to the target after a `ModifierTimeoutPolicy.DROP`.
 *   `NONE` (0)   — the default: leave the target as the payload left it.
 *   `REVERT` (1) — send the same payload to the same target and position with its
 *                  `active` inverted, so a failed unlock does not leave the lock open.
 */
export enum ModifierDropAction {
  NONE = 0,
  REVERT = 1,
}
